import { humanizedScoringRule, ScoringRuleType } from '../../constants/scoringRule';

export const getHumanizeScoringRule = (scoringRule: ScoringRuleType) => {
  return humanizedScoringRule[scoringRule] ?? scoringRule;
};
